var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLines = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 13.333H5.833a.836.836 0 0 0-.833.834v5c0 .458.375.833.833.833H18a.836.836 0 0 0 .833-.833v-5a.836.836 0 0 0-.833-.834M18 5H5.833A.836.836 0 0 0 5 5.833v5c0 .459.375.834.833.834H18a.836.836 0 0 0 .833-.834v-5A.836.836 0 0 0 18 5"
})));
export default SvgLines;